import React, { useEffect, useState } from 'react';
import SeccaoFisioPortal from './components/SeccaoFisioPortal';

const C = {
  purple:"#691FB1", purpleLight:"#EDE7F6", white:"#FFFFFF", text:"#1A1A2E",
  textLight:"#8888AA", border:"#E4DEFA", bg:"#F7F5FC",
};

const SUPA = 'https://btdlohjmjogzkefjmvpn.supabase.co';

const MESES = ['janeiro','fevereiro','março','abril','maio','junho',
               'julho','agosto','setembro','outubro','novembro','dezembro'];
const DIAS = ['domingo','segunda','terça','quarta','quinta','sexta','sábado'];

/* ---------- peças comuns ---------- */

function Cartao({ children, style }) {
  return (
    <div style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:14,
                  padding:'20px 24px', marginBottom:14, ...style }}>
      {children}
    </div>
  );
}

function Titulo({ children, extra }) {
  return (
    <div style={{ display:'flex', alignItems:'baseline', gap:10, flexWrap:'wrap', marginBottom:12 }}>
      <div style={{ fontSize:11, fontWeight:700, color:C.textLight, textTransform:'uppercase', letterSpacing:0.8 }}>
        {children}
      </div>
      {extra && <div style={{ fontSize:11.5, color:C.textLight }}>{extra}</div>}
    </div>
  );
}

/* ---------- avaliação dos serviços pelos participantes ---------- */

function AvaliacaoServicos({ d }) {
  const r1 = (v) => v == null ? '—' : (Math.round(v*10)/10).toLocaleString('pt-PT');
  const t = d.total || {};
  const nomeMes = (ym) => { const [y,m] = String(ym).split('-'); return `${MESES[(+m||1)-1]?.slice(0,3)} ${String(y).slice(2)}`; };
  const Kpi = ({ titulo, valor, sub }) => (
    <div style={{ flex:'1 1 120px', background:C.bg, borderRadius:10, padding:'10px 12px' }}>
      <div style={{ fontSize:10.5, fontWeight:700, color:C.textLight, textTransform:'uppercase', letterSpacing:0.6 }}>{titulo}</div>
      <div style={{ fontSize:22, fontWeight:800, color:C.purple }}>{valor}</div>
      {sub && <div style={{ fontSize:11, color:C.textLight }}>{sub}</div>}
    </div>);
  if (!t.n) return (
    <Cartao><Titulo>Avaliação dos serviços</Titulo>
      <div style={{ fontSize:13, color:C.textLight }}>Ainda não há avaliações dos participantes nos últimos 12 meses.</div></Cartao>);
  const maxN = Math.max(...(d.por_mes || []).map(m => m.n), 1);
  return (
    <Cartao>
      <Titulo extra={`últimos 12 meses · ${t.n} resposta(s) anónima(s)`}>Avaliação dos serviços</Titulo>
      <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:16 }}>
        <Kpi titulo="Satisfação" valor={r1(t.satisfacao)} sub="média de 1 a 5"/>
        <Kpi titulo="NPS" valor={t.nps ?? '—'} sub="recomendação (−100 a 100)"/>
      </div>
      <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12.5, marginBottom:16 }}>
        <thead><tr style={{ color:C.textLight, textAlign:'left' }}><th style={{ padding:'4px 0' }}>Serviço</th><th>Respostas</th><th>Satisfação</th><th>NPS</th></tr></thead>
        <tbody>{(d.por_servico || []).map(x => (
          <tr key={x.k} style={{ borderTop:`1px solid ${C.border}` }}>
            <td style={{ padding:'6px 0', fontWeight:600, color:C.text }}>{x.k}</td><td>{x.n}</td><td>{r1(x.satisfacao)}</td><td>{x.nps ?? '—'}</td>
          </tr>))}</tbody>
      </table>
      {(d.por_mes || []).length > 1 && (<>
        <div style={{ fontSize:11.5, fontWeight:700, color:C.purple, marginBottom:6 }}>Evolução mensal</div>
        <div style={{ display:'flex', gap:6, alignItems:'flex-end', height:110, marginBottom:16, overflowX:'auto' }}>
          {d.por_mes.map(m => (
            <div key={m.k} style={{ flex:'1 0 44px', textAlign:'center' }}>
              <div style={{ fontSize:11, fontWeight:700, color:C.purple }}>{r1(m.satisfacao)}</div>
              <div title={`${m.n} resposta(s)`} style={{ height: Math.max(6, (m.n / maxN) * 64), background:C.purpleLight, borderTop:`3px solid ${C.purple}`, borderRadius:4, margin:'2px 4px' }}/>
              <div style={{ fontSize:10.5, color:C.textLight }}>{nomeMes(m.k)}</div>
            </div>))}
        </div>
        <div style={{ fontSize:11, color:C.textLight, marginTop:-10, marginBottom:14 }}>Número = satisfação média · altura da barra = número de respostas</div>
      </>)}
      {(d.comentarios || []).length > 0 && (<>
        <div style={{ fontSize:11.5, fontWeight:700, color:C.purple, marginBottom:6 }}>O que dizem os participantes</div>
        {d.comentarios.map((c, i) => (
          <div key={i} style={{ borderLeft:`3px solid ${C.purpleLight}`, padding:'4px 10px', marginBottom:8, fontSize:12.5, color:C.text }}>
            <div style={{ fontSize:11, color:C.textLight }}>{c.servico}{c.data ? ` · ${String(c.data).slice(8,10)}/${String(c.data).slice(5,7)}` : ''}</div>
            {c.valorizou && <div>👍 {c.valorizou}</div>}
            {c.melhorar && <div>💡 {c.melhorar}</div>}
          </div>))}
      </>)}
    </Cartao>);
}

/* ---------- mapas de agendamento ---------- */

function Mapas({ mapas }) {
  const hoje = new Date().toISOString().slice(0,10);

  const comData = mapas.map((m,i) => ({ ...m, _i:i, _d:String(m.data).slice(0,10) }));
  const futuros  = comData.filter(m => m._d >= hoje).sort((a,b) => a._d.localeCompare(b._d));
  const passados = comData.filter(m => m._d <  hoje).sort((a,b) => b._d.localeCompare(a._d));

  // agrupa por mês e soma o que interessa ver de fora
  const agrupar = (lista, prefixo) => {
    const gs = [];
    lista.forEach(m => {
      const chave = m._d.slice(0,7);
      let g = gs.find(x => x.chave === chave);
      if (!g) { g = { id:prefixo+chave, chave, mapas:[], marcacoes:0, compareceu:0, faltou:0 }; gs.push(g); }
      g.mapas.push(m);
      const r = m.resumo || {};
      g.marcacoes  += r.marcacoes  || 0;
      g.compareceu += r.compareceu || 0;
      g.faltou     += r.faltou     || 0;
    });
    return gs;
  };

  const mesesFuturos  = agrupar(futuros,  'f-');
  const mesesPassados = agrupar(passados, 'p-');

  // o mês que aí vem abre logo; o resto fica fechado
  const [mesAberto, setMesAberto] = useState(mesesFuturos[0]?.id || null);
  const [aberto, setAberto] = useState(null);

  const EST = {
    'Compareceu':{c:'#27AE60',b:'#EAFAF1'}, 'Chegou atrasado':{c:'#E67E22',b:'#FEF5E7'},
    'Não compareceu':{c:'#C0392B',b:'#FDECEA'}, 'Agendado':{c:C.purple,b:'#EDE7F6'},
    'Livre':{c:C.textLight,b:'#F4F1FB'},
  };

  const rotuloData = d => {
    const dt = new Date(d + 'T00:00:00');
    if (isNaN(dt)) return d;
    return `${DIAS[dt.getDay()].slice(0,3)}, ${dt.getDate()} ${MESES[dt.getMonth()].slice(0,3)}`;
  };
  const rotuloMes = chave => {
    const [a,m] = chave.split('-');
    return `${MESES[Number(m)-1]} ${a}`;
  };
  const chip = (txt, cor, fundo) => (
    <span key={txt} style={{ padding:'2px 8px', borderRadius:10, fontSize:10.5, fontWeight:700,
                             background:fundo, color:cor, whiteSpace:'nowrap' }}>{txt}</span>
  );

  const linha = m => {
    const ab = aberto === m._i;
    const r = m.resumo || {};
    return (
      <div key={m._i} style={{ marginBottom:6 }}>
        <div onClick={() => setAberto(ab ? null : m._i)}
             style={{ display:'flex', alignItems:'center', gap:12, padding:'11px 13px',
                      border:`1px solid ${C.border}`, borderRadius: ab ? '10px 10px 0 0' : 10,
                      background:'#FBFAFF', cursor:'pointer' }}>
          <span style={{ minWidth:78, fontSize:12.5, fontWeight:700, color:C.text }}>{rotuloData(m._d)}</span>
          <span style={{ flex:1, minWidth:0 }}>
            <span style={{ display:'block', fontSize:13.5, fontWeight:700, color:C.purple }}>{m.servico}</span>
            <span style={{ display:'block', fontSize:11, color:C.textLight }}>
              {m.local ? `${m.local} · ` : ''}{String(m.hora_inicio).slice(0,5)}–{String(m.hora_fim).slice(0,5)}
            </span>
          </span>
          <span style={{ display:'flex', gap:5, flexWrap:'wrap', justifyContent:'flex-end' }}>
            {r.marcacoes ? chip(`${r.marcacoes} marcações`, C.purple, '#EDE7F6') : null}
            {r.compareceu ? chip(`${r.compareceu} presenças`, '#27AE60', '#EAFAF1') : null}
            {r.atrasado ? chip(`${r.atrasado} atrasos`, '#E67E22', '#FEF5E7') : null}
            {r.faltou ? chip(`${r.faltou} faltas`, '#C0392B', '#FDECEA') : null}
          </span>
          <span style={{ color:C.textLight, fontSize:13 }}>{ab ? '▲' : '▼'}</span>
        </div>
        {ab && (
          <div style={{ border:`1px solid ${C.border}`, borderTop:'none', borderRadius:'0 0 10px 10px',
                        padding:'10px 13px 12px', background:'#fff',
                        display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))', gap:'0 18px' }}>
            {(m.slots||[]).map((s,j) => (
              <div key={j} style={{ display:'flex', alignItems:'center', gap:9, padding:'6px 0',
                                    borderBottom:'1px solid #F4F1FB', fontSize:12.5 }}>
                <span style={{ fontWeight:700, minWidth:88, whiteSpace:'nowrap' }}>
                  {String(s.hora_inicio).slice(0,5)}–{String(s.hora_fim).slice(0,5)}
                </span>
                <span style={{ flex:1, minWidth:0, color:s.participante?C.text:C.textLight,
                               overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                  {m.nomes_ocultos ? <span style={{ fontStyle:'italic' }}>—</span>
                                   : (s.participante || <span style={{ fontStyle:'italic' }}>livre</span>)}
                </span>
                {s.modalidade === 'Online' &&
                  <span style={{ padding:'2px 7px', borderRadius:10, fontSize:10, fontWeight:700, background:'#E5F1FB', color:'#1A6FA0' }}>online</span>}
                <span style={{ padding:'2px 9px', borderRadius:10, fontSize:10.5, fontWeight:700, whiteSpace:'nowrap',
                               background:(EST[s.estado]||EST['Livre']).b, color:(EST[s.estado]||EST['Livre']).c }}>{s.estado}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const bloco = (titulo, grupos, futuro) => grupos.length === 0 ? null : (
    <div style={{ marginBottom:18 }}>
      <div style={{ fontSize:11.5, fontWeight:700, color:C.purple, marginBottom:8 }}>{titulo}</div>
      {grupos.map(g => {
        const ab = mesAberto === g.id;
        return (
          <div key={g.id} style={{ marginBottom:6 }}>
            <div onClick={() => { setMesAberto(ab ? null : g.id); setAberto(null); }}
                 style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 13px',
                          border:`1px solid ${C.border}`, borderRadius: ab ? '10px 10px 0 0' : 10,
                          background: ab ? '#F4F1FB' : '#fff', cursor:'pointer' }}>
              <span style={{ flex:1, fontSize:13.5, fontWeight:700, color:C.text, textTransform:'capitalize' }}>
                {rotuloMes(g.chave)}
              </span>
              <span style={{ display:'flex', gap:5, flexWrap:'wrap', justifyContent:'flex-end' }}>
                {chip(`${g.mapas.length} ${g.mapas.length === 1 ? 'dia' : 'dias'}`, C.textLight, '#F4F1FB')}
                {futuro
                  ? (g.marcacoes ? chip(`${g.marcacoes} marcações`, C.purple, '#EDE7F6') : null)
                  : (<>
                      {g.compareceu ? chip(`${g.compareceu} presenças`, '#27AE60', '#EAFAF1') : null}
                      {g.faltou ? chip(`${g.faltou} faltas`, '#C0392B', '#FDECEA') : null}
                    </>)}
              </span>
              <span style={{ color:C.textLight, fontSize:13 }}>{ab ? '▲' : '▼'}</span>
            </div>
            {ab && (
              <div style={{ border:`1px solid ${C.border}`, borderTop:'none', borderRadius:'0 0 10px 10px',
                            padding:'10px 10px 4px', background:'#fff' }}>
                {g.mapas.map(linha)}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );

  return (
    <Cartao>
      <Titulo extra={`${mapas.length} no total`}>Mapas de agendamento</Titulo>
      {bloco('Próximas datas', mesesFuturos, true)}
      {mesesFuturos.length === 0 && mesesPassados.length > 0 && (
        <div style={{ fontSize:12.5, color:C.textLight, marginBottom:16 }}>
          Sem datas agendadas de momento.
        </div>
      )}
      {bloco('Já realizadas', mesesPassados, false)}
    </Cartao>
  );
}

/* ---------- portal ---------- */

export default function PortalCliente() {
  const token = window.location.pathname.split('/').filter(Boolean).pop() || '';
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [aCarregar, setACarregar] = useState(true);
  const [notaFat, setNotaFat] = useState(null);
  const [aEnviar, setAEnviar] = useState(false);
  const [notaOk, setNotaOk] = useState('');
  const [verFaturas, setVerFaturas] = useState(false);
  const [auth, setAuth] = useState(null);
  const [email, setEmail] = useState('');
  const [codigo, setCodigo] = useState('');
  const [fase, setFase] = useState('email');
  const [aAutenticar, setAAutenticar] = useState(false);
  const [msgAuth, setMsgAuth] = useState('');

  useEffect(() => {
    // impedir o Safari/iOS de transformar nºs de fatura em links de telefone
    if(!document.querySelector('meta[name="format-detection"]')){
      const m=document.createElement('meta');
      m.name='format-detection'; m.content='telephone=no,date=no,address=no';
      document.head.appendChild(m);
    }
    (async () => { await carregar(); setACarregar(false); })();
    // eslint-disable-next-line
  }, [token]);

  const carregar = async () => {
    const s = localStorage.getItem('portal_s_'+token) || '';
    try {
      const r = await fetch(`${SUPA}/functions/v1/portal-cliente?token=${encodeURIComponent(token)}${s?`&s=${s}`:''}`);
      const d = await r.json();
      if (d.precisaAutenticar) { setAuth({ dica: d.dica }); setDados(null); return; }
      if (d.error) setErro(d.error); else { setDados(d); setAuth(null); }
    } catch { setErro('Não foi possível abrir. Tente novamente.'); }
  };
  const pedirCodigo = async () => {
    if(!email.trim()) return;
    setAAutenticar(true); setMsgAuth('');
    try {
      await fetch(`${SUPA}/functions/v1/portal-cliente`, { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ token, acao:'pedir-codigo', email }) });
      setFase('codigo');
      setMsgAuth('Se este email tiver acesso, receberá um código dentro de instantes.');
    } catch { setMsgAuth('Não foi possível enviar o código.'); }
    setAAutenticar(false);
  };
  const validarCodigo = async () => {
    if(!codigo.trim()) return;
    setAAutenticar(true); setMsgAuth('');
    try {
      const r = await fetch(`${SUPA}/functions/v1/portal-cliente`, { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ token, acao:'validar-codigo', email, codigo }) });
      const d = await r.json();
      if (d.sessao) { localStorage.setItem('portal_s_'+token, d.sessao); await carregar(); }
      else setMsgAuth(d.error || 'Código inválido.');
    } catch { setMsgAuth('Não foi possível validar.'); }
    setAAutenticar(false);
  };

  const eur = (v) => (Number(v)||0).toLocaleString('pt-PT',{minimumFractionDigits:2})+'€';
  const enviarNota = async () => {
    if(!notaFat?.texto?.trim()) return;
    setAEnviar(true);
    try {
      const s = localStorage.getItem('portal_s_'+token) || '';
      const r = await fetch(`${SUPA}/functions/v1/portal-cliente`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ token, sessao:s, fatura: notaFat.numero, nota: notaFat.texto.trim() })
      });
      const d = await r.json();
      if(!d.error){ setNotaOk(notaFat.numero); setNotaFat(null); setDados(d); setTimeout(()=>setNotaOk(''), 6000); }
    } catch {}
    setAEnviar(false);
  };
  const icone = (t) => t==='Relatório'?'📊':t==='Contrato'?'📄':t==='Proposta'?'📝':t==='Fatura'?'🧾':t==='Mapa / Agendamento'?'🗓️':t==='Apresentação'?'📽️':'🔗';

  const docs = dados?.documentos || [];
  const grupo = (t) => t==='Relatório' ? 'Relatórios'
                    : t==='Contrato' ? 'Contratos e propostas'
                    : t==='Proposta' ? 'Contratos e propostas'
                    : t==='Fatura' ? 'Faturação'
                    : 'Outros';
  const SECOES = ['Relatórios','Contratos e propostas','Faturação','Outros'];
  const porSecao = {};
  docs.forEach(d=>{ const g=grupo(d.tipo); (porSecao[g] = porSecao[g]||[]).push(d); });

  return (
    <div style={{ minHeight:'100vh', background:C.bg, fontFamily:"'DM Sans',sans-serif", padding:'32px 16px' }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fraunces:wght@700&display=swap" rel="stylesheet"/>
      <style>{`
        .pc-docs{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:8px}
        .pc-tabela{width:100%;border-collapse:collapse;font-size:13}
        @media (max-width:640px){.pc-tabela{font-size:12}}
      `}</style>
      <div style={{ maxWidth:1040, margin:'0 auto' }}>

        {aCarregar && <div style={{ textAlign:'center', color:C.textLight, fontSize:14, padding:60 }}>A carregar…</div>}

        {erro && (
          <div style={{ background:C.white, borderRadius:16, padding:36, textAlign:'center', maxWidth:460, margin:'40px auto', boxShadow:'0 8px 40px rgba(105,31,177,0.10)' }}>
            <div style={{ fontSize:32, marginBottom:10 }}>🔒</div>
            <div style={{ fontSize:15, color:C.text, fontWeight:700, marginBottom:6 }}>{erro}</div>
            <div style={{ fontSize:13, color:C.textLight }}>Para qualquer questão: apoio@workwell.pt</div>
          </div>
        )}

        {auth && (
          <div style={{ background:C.white, borderRadius:16, padding:36, boxShadow:'0 8px 40px rgba(105,31,177,0.10)', maxWidth:420, margin:'40px auto' }}>
            <div style={{ textAlign:'center', fontSize:30, marginBottom:8 }}>🔐</div>
            <div style={{ textAlign:'center', fontSize:16, fontWeight:700, color:C.purple, marginBottom:6, fontFamily:"'Fraunces',serif" }}>Acesso seguro</div>
            <p style={{ textAlign:'center', fontSize:13, color:C.textLight, margin:'0 0 20px' }}>
              {fase==='email'
                ? <>Para ver os documentos, confirme o seu email.<br/><span style={{ fontSize:12 }}>Sugestão: {auth.dica}</span></>
                : 'Introduza o código de 6 dígitos que enviámos para o seu email.'}
            </p>
            {fase==='email' ? (
              <>
                <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="o.seu.email@empresa.pt"
                  onKeyDown={e=>{ if(e.key==='Enter') pedirCodigo(); }}
                  style={{ width:'100%', boxSizing:'border-box', padding:'12px 14px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:14, fontFamily:"'DM Sans',sans-serif", marginBottom:10 }}/>
                <button onClick={pedirCodigo} disabled={aAutenticar||!email.trim()}
                  style={{ width:'100%', padding:'12px', border:'none', borderRadius:8, background:!email.trim()?'#C9BCE8':C.purple, color:'#fff', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                  {aAutenticar?'A enviar…':'Receber código'}</button>
              </>
            ) : (
              <>
                <input value={codigo} onChange={e=>setCodigo(e.target.value.replace(/\D/g,'').slice(0,6))} placeholder="000000" inputMode="numeric"
                  onKeyDown={e=>{ if(e.key==='Enter') validarCodigo(); }}
                  style={{ width:'100%', boxSizing:'border-box', padding:'12px 14px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:22, letterSpacing:8, textAlign:'center', fontFamily:"'DM Sans',sans-serif", marginBottom:10 }}/>
                <button onClick={validarCodigo} disabled={aAutenticar||codigo.length<6}
                  style={{ width:'100%', padding:'12px', border:'none', borderRadius:8, background:codigo.length<6?'#C9BCE8':C.purple, color:'#fff', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                  {aAutenticar?'A validar…':'Entrar'}</button>
                <button onClick={()=>{setFase('email');setCodigo('');setMsgAuth('');}}
                  style={{ width:'100%', marginTop:8, padding:'8px', background:'none', border:'none', color:C.textLight, fontSize:12, cursor:'pointer', textDecoration:'underline', fontFamily:"'DM Sans',sans-serif" }}>Usar outro email</button>
              </>
            )}
            {msgAuth&&<div style={{ marginTop:12, fontSize:12, color:C.textLight, textAlign:'center' }}>{msgAuth}</div>}
          </div>
        )}

        {dados && (
          <>
            <div style={{ background:C.purple, borderRadius:14, padding:'20px 28px', marginBottom:14,
                          display:'flex', alignItems:'center', gap:18, flexWrap:'wrap' }}>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ color:'#fff', fontSize:20, fontFamily:"'Fraunces',serif" }}>{dados.projeto?.cliente || 'Workwell'}</div>
                <div style={{ color:'#E4DEFA', fontSize:14, marginTop:2 }}>Portal Workwell</div>
              </div>
              <img src="/workwell-selo-branco.png"
                   srcSet="/workwell-selo-branco.png 1x, /workwell-selo-branco-2x.png 2x"
                   alt="Workwell" style={{ height:78, width:'auto', display:'block', flex:'none' }} />
            </div>

            {/* 1 · indicadores de fisioterapia */}
            {(!dados.modulos || dados.modulos.fisio) &&
              <SeccaoFisioPortal token={token} sessao={localStorage.getItem('portal_s_'+token) || ''} />}

            {/* avaliação dos serviços pelos participantes */}
            {dados.modulos && dados.modulos.avaliacao_servicos && dados.avaliacao_servicos && <AvaliacaoServicos d={dados.avaliacao_servicos}/>}

            {/* 2 · documentos e relatórios */}
            {(!dados.modulos || dados.modulos.documentos) && <Cartao>
              <Titulo extra={docs.length ? `${docs.length} documento(s)` : null}>Documentos e relatórios</Titulo>
              {docs.length === 0 ? (
                <div style={{ fontSize:13, color:C.textLight }}>
                  Ainda não há documentos partilhados. Assim que estiverem disponíveis, aparecem aqui.
                </div>
              ) : SECOES.filter(s=>porSecao[s]?.length).map(sec=>(
                <div key={sec} style={{ marginBottom:16 }}>
                  <div style={{ fontSize:11.5, fontWeight:700, color:C.purple, marginBottom:8 }}>{sec}</div>
                  <div className="pc-docs">
                    {porSecao[sec].map((d,i)=>(
                      <a key={i} href={d.url} target="_blank" rel="noreferrer"
                         style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 13px',
                                  border:`1px solid ${C.border}`, borderRadius:10, textDecoration:'none', background:'#FBFAFF' }}>
                        <span style={{ fontSize:19 }}>{icone(d.tipo)}</span>
                        <span style={{ flex:1, minWidth:0 }}>
                          <span style={{ display:'block', fontSize:13.5, fontWeight:700, color:C.purple, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{d.titulo}</span>
                          <span style={{ display:'block', fontSize:11, color:C.textLight }}>{d.tipo}{d.projeto?` · ${d.projeto}`:''}{d.created_at?` · ${String(d.created_at).slice(0,10)}`:''}</span>
                        </span>
                        <span style={{ color:C.textLight, fontSize:16 }}>↗</span>
                      </a>
                    ))}
                  </div>
                </div>
              ))}
            </Cartao>}

            {/* 3 · mapas de agendamento */}
            {(dados.mapas||[]).length>0 && <Mapas mapas={dados.mapas} />}

            {/* 4 · faturação */}
            {(dados.faturas||[]).length>0 && (
              <Cartao>
                <Titulo extra={`${dados.faturas.length} fatura(s)`}>Faturação</Titulo>
                <div onClick={()=>setVerFaturas(v=>!v)}
                  style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 13px',
                           border:`1px solid ${C.border}`, borderRadius:verFaturas?'10px 10px 0 0':10, background:'#FBFAFF', cursor:'pointer' }}>
                  <span style={{ fontSize:19 }}>🧾</span>
                  <span style={{ flex:1 }}>
                    <span style={{ display:'block', fontSize:13.5, fontWeight:700, color:C.purple }}>Faturas emitidas</span>
                    <span style={{ display:'block', fontSize:11, color:C.textLight }}>clique para ver o detalhe</span>
                  </span>
                  <span style={{ color:C.textLight, fontSize:13 }}>{verFaturas?'▲':'▼'}</span>
                </div>
                {verFaturas&&(
                  <div style={{ border:`1px solid ${C.border}`, borderTop:'none', borderRadius:'0 0 10px 10px', padding:'4px 14px 12px', background:'#fff', overflowX:'auto' }}>
                    <table className="pc-tabela">
                      <thead>
                        <tr>
                          {['Nº fatura','Data de emissão','Nota','Valor (sem IVA)','Total c/ IVA',''].map((h,i)=>(
                            <th key={h||'x'} style={{ padding:'8px 6px', textAlign:i>=3?'right':'left', fontSize:10, color:C.textLight, fontWeight:700, borderBottom:`1px solid ${C.border}`, whiteSpace:'nowrap' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {dados.faturas.map((f,i)=>([
                          <tr key={i} style={{ borderBottom:'1px solid #F4F1FB' }}>
                            <td style={{ padding:'9px 6px', fontWeight:700, color:C.purple, whiteSpace:'nowrap' }}>{f.numero}</td>
                            <td style={{ padding:'9px 6px', color:C.textLight, whiteSpace:'nowrap' }}>{f.data_emissao}</td>
                            <td style={{ padding:'9px 6px', color:C.textLight }}>{f.nota||'—'}</td>
                            <td style={{ padding:'9px 6px', textAlign:'right', fontWeight:700, whiteSpace:'nowrap' }}>{eur(f.valor_liquido!=null?f.valor_liquido:f.valor)}</td>
                            <td style={{ padding:'9px 6px', textAlign:'right', color:C.textLight, whiteSpace:'nowrap' }}>{eur(f.valor)}</td>
                            <td style={{ padding:'9px 6px', textAlign:'right', whiteSpace:'nowrap' }}>
                              <button onClick={()=>setNotaFat(notaFat?.numero===f.numero?null:{ numero:f.numero, texto:'' })}
                                title={f.nota_cliente ? `A sua nota: ${f.nota_cliente}` : 'Deixar uma nota sobre esta fatura'}
                                style={{ border:'none', background:'transparent', cursor:'pointer', fontSize:14, opacity:f.nota_cliente?1:0.45 }}>💬</button>
                            </td>
                          </tr>,
                          (notaFat?.numero===f.numero || f.nota_cliente || notaOk===f.numero) && (
                            <tr key={i+'-n'}>
                              <td colSpan={6} style={{ padding:'0 6px 10px' }}>
                                {f.nota_cliente && (
                                  <div style={{ background:'#F7F5FC', borderLeft:`3px solid ${C.purple}`, padding:'8px 10px', fontSize:12, color:C.text, marginBottom:6 }}>
                                    {f.nota_cliente}
                                    <span style={{ display:'block', fontSize:10, color:C.textLight, marginTop:3 }}>enviada a {String(f.nota_cliente_em||'').slice(0,10)}</span>
                                  </div>
                                )}
                                {notaOk===f.numero && <div style={{ fontSize:12, color:'#27AE60', fontWeight:700 }}>✓ Nota enviada ao nosso financeiro.</div>}
                                {notaFat?.numero===f.numero && (
                                  <div>
                                    <textarea value={notaFat.texto} onChange={e=>setNotaFat({...notaFat, texto:e.target.value})} rows={2}
                                      placeholder={`Questão ou observação sobre a fatura ${f.numero}…`}
                                      style={{ width:'100%', boxSizing:'border-box', padding:'8px 10px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:12, fontFamily:"'DM Sans',sans-serif", resize:'vertical' }}/>
                                    <div style={{ display:'flex', gap:8, marginTop:6 }}>
                                      <button onClick={enviarNota} disabled={aEnviar||!notaFat.texto.trim()}
                                        style={{ background:!notaFat.texto.trim()?'#C9BCE8':C.purple, border:'none', borderRadius:6, color:'#fff', padding:'7px 14px', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
                                        {aEnviar?'A enviar…':'Enviar ao financeiro'}</button>
                                      <button onClick={()=>setNotaFat(null)}
                                        style={{ background:'#fff', border:`1px solid ${C.border}`, borderRadius:6, color:C.textLight, padding:'7px 12px', fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Cancelar</button>
                                    </div>
                                  </div>
                                )}
                              </td>
                            </tr>
                          )
                        ]))}
                      </tbody>
                    </table>
                    <div style={{ fontSize:10, color:C.textLight, marginTop:8 }}>Valor sem IVA e total com IVA.</div>
                  </div>
                )}
              </Cartao>
            )}

            <div style={{ fontSize:11, color:C.textLight, padding:'4px 4px 0' }}>
              Partilhado com {dados.para}. Se precisar de mais alguma coisa, fale com a equipa Workwell para apoio@workwell.pt.
            </div>
            <div style={{ textAlign:'center', fontSize:11, color:C.textLight, marginTop:16 }}>
              Outras plataformas automatizam. A WOW humaniza.
            </div>
          </>
        )}
      </div>
    </div>
  );
}
